import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import "../horizontalScroll/horizontalScroll.scss"


const HorizontalScroll = ({ items }) => {
    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: targetRef,
    });

    const x = useTransform(
        scrollYProgress,
        [0, 1],
        ["0%", `-${((items.length) * 65) - 75}vh`]
    );

    return (
        <div ref={targetRef} className="horizontalScroll" style={{ height: `${(items.length) * 50}vh` }}>
            <div className="sticky">
                <motion.div
                    className="list"
                    style={{ left: x }}
                >
                    <motion.div
                        className="heading"
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <h1>Geschichte</h1>
                        <a href={"#vorstand"}>
                            <ArrowDownwardIcon />
                        </a>
                    </motion.div>
                    {items.map((item, index) => (
                        <motion.div
                            key={index}
                            className="item"
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                        >
                            <h1>{item.title.rendered}</h1>
                            <div className="box">
                                <div className="content">
                                    <h2>{item.acf.title}</h2>
                                    <p>{item.acf.inhalt}</p>
                                </div>
                                {item.acf.image &&
                                    <img
                                        src={item.acf.image.sizes.large}
                                        alt={item.title.rendered}
                                    />
                                }
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </div>
    )
};

export default HorizontalScroll